<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>

    <div v-show="!modoPesquisa">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdos) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Inclusão</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtinclusao) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ objView.nmpessoa }}</div>
                </div>

                <div class="form-item-char40">
                    <label class="label-caption">Localidade</label>
                    <div class="field-label">{{ objView.nmlocalidade }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Grupo</label>
                    <div class="field-label">{{ objView.nmgrupo }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Equipamento</label>
                    <div class="field-label">{{ objView.nmequipamento }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Implemento</label>
                    <div class="field-label">{{ objView.nmimplemento }}</div>
                </div>
            </div>
            

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Serviço</label>
                    <div class="field-label">{{ objView.nmservico }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Contratado</label>
                    <div class="field-label field-label-center">{{ objView.hrcontratadas }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Executado</label>
                    <div class="field-label field-label-center">{{ objView.hrtrabalhadas }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Data/Hora Início</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtinicio) }} - {{ Funcoes.formatTimeFromJson(objView.hrinicio) }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Data/Hora Fim</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtfim) }} - {{ Funcoes.formatTimeFromJson(objView.hrfim) }}</div>
                </div>
            </div>

            <div class="row-end">
                <button class="btn-small btn-save" @click="recalcularOS()">Recalcular</button>
                <button class="btn-small" @click="modoPesquisa=true">Pesquisar</button>
                <button class="btn-small" @click="closeForm()">Voltar</button>
            </div>
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Descrição</th>
                        <th>Operador</th>
                        <th>Horas/Km</th>
                        <th>Entregas</th>
                        <th>Coordenadas</th>
                        <th>Imagens</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(obj, index) in lsDados" :key="obj.id">
                        <tr :class="{
                            'alert-row': obj.estorno_dh != null,
                            'even-row': obj.estorno_dh == null && index % 2 === 0,
                            'odd-row': obj.estorno_dh == null && index % 2 !== 0,
                            'clickabe': true
                            }"
                            @click="toggleDetalhes(obj)"
                        >
                            <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtevento) }}</td>
                            <td class="col-width-date center">{{ Funcoes.formatTimeFromJson(obj.hrevento) }}</td>
                            <td>{{ obj.xtpevento }}</td>
                            <td class="col-width-char40">{{ obj.nmoperador }}</td>
                            <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.horaskm) }}</td>
                            <td class="col-width-char10 center">{{ Funcoes.formatDecimal(obj.ttentregas, 1) }}</td>
                            <td class="col-width-char20 center label-link" @click.stop="abrirMapa(obj)">{{ obj.latitude }} x {{ obj.longitude }}</td>
                            <td class="col-width-char10 center label-link" @click.stop="abrirFotos(obj)">{{ (obj.idanexo) || (obj.idanexo2) ? 'SIM' : 'NÃO' }}</td>
                        </tr>
                        

                        <tr v-show="eventoEdicao.id == obj.id">
                            <td colspan="8">
                                <div class="row-start row-space">
                                    <strong>{{ obj.xmanual }}</strong> - {{ obj.nmusuario }}
                                </div>

                                <div class="row row-space">
                                    <div class="form-item-data">
                                        <label class="label-caption">Data</label>
                                        <input type="date" v-model="eventoEdicao.dtevento" />
                                    </div>

                                    <div class="form-item-char10">
                                        <label class="label-caption">Hora</label>
                                        <input type="time" v-model="eventoEdicao.hrevento" />
                                    </div>
                                    
                                    <div class="form-item-char15">
                                        <label class="label-caption">Horas/KM</label>
                                        <input v-model="eventoEdicao.horaskm" v-decimal type="text" class="input-right" />
                                    </div>

                                    <div class="form-item-char15">
                                        <label class="label-caption">Entregas</label>
                                        <input v-model="eventoEdicao.ttentregas" v-decimal type="text" class="input-right" />
                                    </div>
                                    
                                    <div class="form-item">
                                        <label class="label-caption">Observações</label>
                                        <input type="text" v-model="eventoEdicao.observacoes" maxlength="100" v-uppercase />
                                    </div>
                                </div>

                                <div class="row-start">
                                    <button class="btn-small" @click="salvarEdicao">Salvar</button>
                                    <button class="btn-small btn-delete" @click="estornarEvento(obj)">Estornar</button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>


        <div class="form-panel margin-top05">
            <div class="form-panel-header">Inclusão de novos eventos na OS</div>
            <div class="form-panel-body">
                <div class="row row-space">
                    <div class="form-item-data">
                        <label class="label-caption">Data</label>
                        <input type="date" v-model="eventoInclusao.dtevento" />
                    </div>

                    <div class="form-item-char10">
                        <label class="label-caption">Hora</label>
                        <input type="time" v-model="eventoInclusao.hrevento" />
                    </div>
                    
                    <div class="form-item-char15">
                        <label class="label-caption">Horas/KM</label>
                        <input v-model="eventoInclusao.horaskm" v-decimal type="text" class="input-right" />
                    </div>

                    <div class="form-item-char15">
                        <label class="label-caption">Entregas</label>
                        <input v-model="eventoInclusao.ttentregas" v-decimal type="text" class="input-right" />
                    </div>

                    <OperadorSelect class="form-item" v-model:idSelecionado="eventoInclusao.idoperador" />

                </div>
                
                <div class="row row-space">
                    <div class="form-item-char20">
                        <EventoTpEventoSelect v-model:opcaoSelecionada="eventoInclusao.tpevento" />
                    </div>
                    
                    <div class="form-item">
                        <label class="label-caption">Observações</label>
                        <input type="text" v-model="eventoInclusao.observacoes" maxlength="100" v-uppercase />
                    </div>
                    <button class="btn-small" @click="salvarInclusao">Incluir</button>
                </div>
            </div>
        </div>
    </div>



    <div v-if="fotosEvento.length" class="evento-fotos-box">
        <div class="evento-fotos-grid">
            <div
                v-for="foto in fotosEvento"
                :key="foto.id"
                class="foto-card"
            >
                <div class="foto-preview" @click="visualizarFoto(foto.url)">
                    <img :src="foto.url" :alt="foto.titulo" />
                </div>

                <div class="foto-actions">
                    <span class="foto-titulo">{{ foto.titulo }}</span>
                    <button class="btn-foto" @click="abrirFotoNovaAba(foto.url)">
                        Abrir em nova aba
                    </button>
                </div>
            </div>
        </div>
    </div>


    <div v-if="showFotoModal" class="foto-modal-overlay" @click="showFotoModal = false">
        <div class="foto-modal-content" @click.stop>
            <button class="foto-modal-close" @click="showFotoModal = false">×</button>

            <img :src="fotoModalUrl" alt="Foto ampliada" class="foto-modal-img" />

            <div class="foto-modal-actions">
                <button class="btn-foto" @click="abrirFotoNovaAba(fotoModalUrl)">
                    Abrir em nova aba
                </button>
            </div>
        </div>
    </div>

    <div v-show="modoPesquisa">
        <OsExecutadasTabPage :modoPesquisa="true" @update:objSelecionado="setOs" @close="modoPesquisa = false" />
    </div>

    <ConfirmModal ref="confirmModal" />
    <ModalJustificativaTexto ref="modalJustificativa" />
</template>

<script setup>
import { ref, reactive } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarEvento } from '@/models/Evento.js';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes.js';
import EventoTpEventoSelect from '@/selects/estaticos/EventoTpEventoSelect.vue';
import ModalJustificativaTexto from '@/components/modals/ModalJustificativaTexto.vue';
import OperadorSelect from '@/selects/OperadorSelect.vue';
import OsExecutadasTabPage from './OsExecutadasTabPage.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';

const emit=defineEmits(['close']);

const confirmModal = ref(null);
const idOs = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modalJustificativa = ref(null);
const modoPesquisa = ref(true);
const msgAlerta = ref(null);
const objView = ref({});

const fotosEvento = ref([]);
const showFotoModal = ref(false);
const fotoModalUrl = ref('');

const eventoEdicao = reactive({
    id: 0,
    dtevento: '',
    hrevento: '',
    observacoes: '',
    horaskm: 0,
    ttentregas: 0,
    idlogin: globalStore.idlogin,
});

let eventoInclusao = criarEvento();


const abrirFotos = async(obj) =>{
    fotosEvento.value = [];
    msgAlerta.value = null;

    if ((!obj.idanexo) && (!obj.idanexo2)){
        msgAlerta.value = 'Evento não possui fotos anexadas';
        return;
    }
    
    try {
        msgAlerta.value = null;
        if (obj.idanexo){
            const r = await Api.genericPost('/main/solicitar/download', {id: obj.idanexo});
            if (r.bolok === 1 && r.download_url){
                fotosEvento.value.push({
                    id: obj.idanexo,
                    url: r.download_url,
                    titulo: 'Foto 1'
                });
            }
        }

        if (obj.idanexo2){
            const r = await Api.genericPost('/main/solicitar/download', {id: obj.idanexo2});
            if (r.bolok === 1 && r.download_url) {
                fotosEvento.value.push({
                    id: obj.idanexo2,
                    url: r.download_url,
                    titulo: 'Foto 2'
                });
            }
        }

        if (fotosEvento.value.length === 0) {
            msgAlerta.value = 'Não foi possível carregar as fotos do evento';
        }
    } catch (error) {
        msgAlerta.value = `Erro ao carregar fotos: ${error.message}`;
    }
}


const abrirFotoNovaAba = (url) => {
    window.open(url, '_blank');
}


const abrirMapa = async(obj) =>{
    if ((!obj.latitude) || (!obj.longitude)){
        msgAlerta.value = 'Evento não possui coordenadas';
    }else{
        msgAlerta.value = null;
        const zoom = 15;
        const url = `https://www.google.com/maps?q=${obj.latitude},${obj.longitude}&t=k&z=${zoom}`;
        window.open(url, '_blank');
    }
}

const closeForm = () => {emit('close');}


async function estornarEvento(obj){
    const rModal = await modalJustificativa.value.show();
    if (!rModal.confirmado) return;

    try {
        isLoading.value = true;
        const r = await Api.genericPut('/cad/evento', {
            id: obj.id,
            estorno_idlogin: globalStore.idlogin,
            estorno_obs: rModal.justificativa,
            idlogin: globalStore.idlogin,
        });
        if (r.bolok!=1){msgAlerta.value = r.erro; return;}
        eventoEdicao.id=0;
        await lerDados();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerDados() {
    msgAlerta.value = null;
    if (!idOs.value) return;

    try{
        isLoading.value = true;
        const req = await Api.genericPost('/os/vwos', {
            idmunicipio: globalStore.idmunicipio, 
            idos: idOs.value});
        Object.assign(objView.value, req[0]);

        const h = await Api.genericPost('/os/eventos', {
            idos: idOs.value,
            intparam1: 1,
        });
        lsDados.value = h ?? [];
    }catch (error){msgAlerta.value = error;
    }finally{isLoading.value = false;}
}


async function recalcularOS(){
    const confirmado = await confirmModal.value.show({
        message: 'Confirma execução do recalculo desta ordem de serviço?',
        confirmText: 'Sim',
        cancelText: 'Não',
    });
    if (!confirmado){return}
    msgAlerta.value=null;
    try{
        isLoading.value=true;
        const r = await Api.genericPost('/rotinas/executar', {
            nmrequisicao: 'osRecalcularHoras',
            idmunicipio: globalStore.idmunicipio,
            idreferencia: objView.value.id,
            idlogin: globalStore.idlogin,
        });
        if (r.bolok!=1){msgAlerta.value = r.erro; return;}
        await lerDados();
    }catch(error){
        msgAlerta.value = `Atenção: ${error}`;
    }finally{
        isLoading.value=false;
    }
}


async function salvarEdicao(){
    eventoEdicao.horaskm=Funcoes.decimalFromString(eventoEdicao.horaskm);
    eventoEdicao.ttentregas=Funcoes.decimalFromString(eventoEdicao.ttentregas);

    let m = '';
    msgAlerta.value=null;
    let x = Validar.data(eventoEdicao.dtevento,-1000);
    if (x.ok==false) m+='\n-Informe a data corretamente';
    x = Validar.hora(eventoEdicao.hrevento);
    if (x.ok==false) m+='\n-Informe a hora corretamente';
    if (eventoEdicao.horaskm<=0) m+='\n-"Horas/KM" deve ser maior que ZERO';
    if (eventoEdicao.ttentregas<0) m+='\n-"Entragas" não pode ser menor que ZERO';
    if(m){
        msgAlerta.value=`ATENÇÃO: ${m}`
        return;
    }

    try{
        isLoading.value=true;
        const r = await Api.genericPut('/cad/evento', eventoEdicao);
        if (r.bolok!=1){msgAlerta.value = r.msg; return;}
        eventoEdicao.id=null;
        await lerDados();
    }catch(error){
        msgAlerta.value = `Atenção: ${error}`;
    }finally{
        isLoading.value=false;
    }
}


async function salvarInclusao(){
    eventoInclusao.horaskm=Funcoes.decimalFromString(eventoInclusao.horaskm);
    eventoInclusao.ttentregas=Funcoes.decimalFromString(eventoInclusao.ttentregas);

    let m = '';
    msgAlerta.value=null;
    let x = Validar.data(eventoInclusao.dtevento,-1000);
    if (x.ok==false) m+='\n-Informe a data corretamente';
    x = Validar.hora(eventoInclusao.hrevento);
    if (x.ok==false) m+='\n-Informe a hora corretamente';
    if (eventoInclusao.horaskm<=0) m+='\n-"Horas/KM" deve ser maior que ZERO';
    if (eventoInclusao.ttentregas<0) m+='\n-"Entragas" não pode ser menor que ZERO';
    if (!eventoInclusao.tpevento) m+='\n-Informe o tipo de evento';
    if(m){
        msgAlerta.value=`ATENÇÃO: ${m}`
        return;
    }

    try{
        isLoading.value=true;
        eventoInclusao.idmunicipio=globalStore.idmunicipio;
        eventoInclusao.idequipamento=objView.value.idequipamento; // testar
        eventoInclusao.idos=objView.value.id;
        eventoInclusao.manual=1;
        eventoInclusao.idlogin=globalStore.idlogin;

        const r = await Api.genericPut('/cad/evento', eventoInclusao);
        if (r.bolok!=1){msgAlerta.value = r.msg; return;}

        eventoInclusao=criarEvento();
        await lerDados();
    }catch(error){
        msgAlerta.value = `Atenção: ${error}`;
    }finally{
        isLoading.value=false;
    }
}


async function setOs(obj){
    idOs.value = obj.id;
    await lerDados();
}


function toggleDetalhes(obj) {
    if (eventoEdicao.id === obj.id  || obj.estorno_dh) {
        eventoEdicao.id = 0;
    } else {
        eventoEdicao.id = obj.id;
        eventoEdicao.dtevento = obj.dtevento;
        eventoEdicao.hrevento = Funcoes.formatTimeFromJson(obj.hrevento);
        eventoEdicao.horaskm = obj.horaskm;
        eventoEdicao.ttentregas = obj.ttentregas;
        eventoEdicao.observacoes = obj.observacoes;
    }
}


const visualizarFoto = (url) => {
    fotoModalUrl.value = url;
    showFotoModal.value = true;
}
</script>


<style scoped>
.evento-fotos-box {
    margin-top: 16px;
    padding: 8px;
}

.evento-fotos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
    gap: 16px;
}

.foto-card {
    border-radius: 10px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 3px 8px rgba(0,0,0,0.08);
    transition: transform 0.15s ease;
}

.foto-card:hover {
    transform: translateY(-2px);
}

.foto-preview {
    width: 100%;
    height: clamp(260px, 30vw, 420px);
    background: #eef4f8;
    cursor: pointer;
    overflow: hidden;
}

.foto-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.35s ease;
}

.foto-preview:hover img {
    transform: scale(1.08);
}

.foto-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
}

.foto-titulo {
    font-size: 0.85rem;
    color: #6b7280;
    font-weight: 500;
}

.btn-foto {
    border: none;
    background: transparent;
    color: #3b82f6;
    font-size: 0.8rem;
    cursor: pointer;
    padding: 4px;
}

.btn-foto:hover {
    text-decoration: underline;
}

.foto-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.78);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
}

.foto-modal-content {
    position: relative;
    max-width: 96vw;
    max-height: 96vh;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.22);
}

.foto-modal-img {
    max-width: 92vw;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 8px;
    background: #f8fafc;
}

.foto-modal-close {
    position: absolute;
    top: 8px;
    right: 8px;
    border: none;
    background: rgba(0,0,0,0.65);
    color: #fff;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}

.foto-modal-actions {
    display: flex;
    justify-content: flex-end;
}

.btn-foto-modal {
    font-size: 0.9rem;
}
</style>